module.exports = __webpack_public_path__ + "static/build-66946eb9306b4314bae48035288eea9c.png";